import React, { useEffect, useState } from "react";
import axios from "axios";
import ImageGallery from "../Components/ImageGallery";
import { API } from "../Api";





const Gallery = () => {
  const [data, setData] = useState(null);
  const [festival, setFestival] = useState(null);
  const [award, setAward] = useState(null);
  const [general, setGeneral] = useState(null);
  const [college, setCollege] = useState(null);

  const fetchPhotos = async () => {
    try {
      const res = await axios.get(`${API}/api/events`); 
      const newData = res.data;
      setData(newData);
     
    } catch (error) {
      console.log("Error fetching gallery:", error);
    }
  };

  useEffect(() => {
    console.log('festival');
   
    console.log(festival);
      

     fetchPhotos();
      
  
  }, []);

  return (
    <div style={{ padding: "20px" }}>

       <h2  className="headers">
        General Events
      </h2>
      <ImageGallery data={data && data.filter((d)=> d.eventtype == 'general') } />



      <h2   className="headers">
        College Events
      </h2>
       
     <ImageGallery data={data && data.filter((d)=> d.eventtype == 'college') } />
        <h2  className="headers">
        Award Events
      </h2>
     <ImageGallery data={data && data.filter((d)=> d.eventtype == 'award') } />
       
        <h2  className="headers">
       Festival Events
      </h2>
     <ImageGallery data={data && data.filter((d)=> d.eventtype == 'festival')} />
    </div>
  );
};

export default Gallery;
